import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SmartRender from "containers/SmartRender";
import {
  makeSelectEligiblePlans,
  makeSelectPlanDetails,
  makeSelectReferralCode,
  makeSelectAddons,
  makeSelectPreSelectedAddons,
  makeSelectPayTodayItems,
  makeSelectPlanName,
  makeSelectThemeColors
} from "ducks/selectors";
import {
  selectPlan,
  fetchReferralCode,
  clearData,
  setData
} from "ducks/actions";

import { tabTypes } from "utils/constants";

const PlanSelection = SmartRenderComp =>
  function Component(props) {
    const dispatch = useDispatch();

    const planName = useSelector(makeSelectPlanName());
    const eligiblePlans = useSelector(makeSelectEligiblePlans());
    const planDetails = useSelector(makeSelectPlanDetails());
    const referralCode = useSelector(makeSelectReferralCode());
    const addOns = useSelector(makeSelectAddons());
    const payTodayItems = useSelector(makeSelectPayTodayItems());
    const themeColors = useSelector(makeSelectThemeColors());

    const defaultAddons = useSelector(makeSelectPreSelectedAddons());

    useEffect(() => {
      if (eligiblePlans) {
        const selectedPlan = eligiblePlans[0];
        selectPlan(selectedPlan);
      }
    }, [eligiblePlans]);

    const onSelectPlan = plan => {
      dispatch(selectPlan(plan));
    };

    const validateReferralCode = referral_code => {
      dispatch(fetchReferralCode({ referral_code }));
    };

    const resetReferralCode = () =>
      dispatch(clearData(["referralCode", "selectedAddons"]));

    const handleSelectAddon = (addonId, selected) =>
      dispatch(
        setData({ key: "selectedAddons", data: { [addonId]: selected } })
      );

    return (
      <SmartRenderComp
        {...props}
        planName={planName}
        eligiblePlans={eligiblePlans}
        selectPlan={onSelectPlan}
        planDetails={planDetails}
        referralCode={referralCode}
        addOns={addOns}
        defaultAddons={defaultAddons}
        validateReferralCode={validateReferralCode}
        resetReferralCode={resetReferralCode}
        handleSelectAddon={handleSelectAddon}
        payTodayItems={payTodayItems}
        tabType={tabTypes.PILL}
        themeColors={themeColors}
        nobox
      />
    );
  };

export default PlanSelection(SmartRender);
